import { useMemo } from "react";
import { useChecklists } from "@/hooks/useChecklists";
import { usePropertyPreventativeMaintenance } from "@/hooks/usePreventativeMaintenance";
import ChecklistRulesSection from "./ChecklistRulesSection";

interface AutomationsTabProps {
  propertyId: string;
}

const AutomationsTab = ({ propertyId }: AutomationsTabProps) => {
  const { data: checklists, isLoading } = useChecklists(propertyId);
  const { data: propertyPpm = [] } = usePropertyPreventativeMaintenance(propertyId);
  const pmChecklistIds = new Set((propertyPpm ?? []).map((p) => p.checklist_id).filter(Boolean) as string[]);

  const displayChecklists = useMemo(() => {
    if (!checklists || !Array.isArray(checklists)) return [];
    return checklists.filter((c) => !pmChecklistIds.has(c.id));
  }, [checklists, pmChecklistIds]);

  if (isLoading) {
    return (
      <div className="max-w-4xl mx-auto">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      {displayChecklists.length > 0 ? (
        <ChecklistRulesSection propertyId={propertyId} checklists={displayChecklists} />
      ) : (
        <p className="text-sm text-muted-foreground">
          Create at least one turnover checklist on the Checklist tab before you can add automation rules.
        </p>
      )}
    </div>
  );
};

export default AutomationsTab;
